import { ReferenceLibraryElementTypesEnum } from "@second-brain/shared";

export const ReferenceLibraryElementLink = (props: {
  props: {
    id: number;
    name: string;
    type: number;
    physicalLibraryLocation?: { id: number; name: string };
    body?: string;
    elements?: { id: number; name: string; type: number };
  };
}) => {
  return (
    <div>
      {props.props.type === ReferenceLibraryElementTypesEnum.Document && (
        <>
          <b className="reference-library-element-name">{props.props.name}</b>
          {props.props.body && (
            <div className="document-body-content">{props.props.body}</div>
          )}
        </>
      )}
      {props.props.type === ReferenceLibraryElementTypesEnum.Link && (
        <a href={props.props.body}>{props.props.name}</a>
      )}
      {props.props.type === ReferenceLibraryElementTypesEnum.PhysicalItem && (
        <div>
          <b className="reference-library-element-name">{props.props.name}</b>
          {props.props.physicalLibraryLocation && (
            <div className="physical-location">
              {props.props.physicalLibraryLocation.name}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
